import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { View,  Image, Platform } from 'react-native';
import Modal from 'react-native-modal'
import { Text } from '@constants/Themed';
import { BlurView } from '@react-native-community/blur';
import styles from '@stylesheet';
import toTitleCase from '@hooks/toTitleCase';
import { CountUp } from 'use-count-up';
import AnimatedLottieView from '@utils/lottieAnimation';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';

export type UserInfoModalHandle = {
  toggleVisibility: () => void;
};

type UserType = {
  email: string;
  profile_information: {
    name: string;
    surname: string;
    avatar: {
      img: string;
    }
  },
  achievements: {
    achievement_points: number;
  }
  
}
const UserInfoModal = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const theme = useSelector((state: DefaultRootState) => state.app.theme.lightTheme);
  const [user, setUser] = useState<UserType>();

  useImperativeHandle(ref, () => {
    return {
      toggleVisibility: (user) => {
        setVisible(!visible); // Toggle the visibility
        setUser(user)
      },
    };
  }, [visible]); // Add 'visible' as a dependency


  return user && (
    <Modal animationIn={'zoomIn'} animationOut={'zoomOut'} isVisible={visible} backdropColor='transparent' onBackdropPress={() => setVisible(false)} style={[styles.modalContainerAuth, styles.centerEverything, { maxHeight: '40%', maxWidth: '80%', alignSelf: 'center', justifyContent: 'center', margin: '40%', top: 100, left: 25, backgroundColor: '#ffffff66' }]}>
      <BlurView style={styles.blurViewStyle} blurType={theme ? 'light' : "dark"} blurAmount={10} reducedTransparencyFallbackColor="white" pointerEvents='none' />
      <View style={{ flex: 1, borderRadius: 20, minWidth: 400, minHeight: 400, padding: 20, paddingTop: -4 }}>
        <View style={{ backgroundColor: 'white', flexDirection: 'row', flex: 1, padding: 20 }}>
          <View style={{ flex: 1, borderTopLeftRadius: 20, borderBottomLeftRadius: 20, padding: 20 }} >
            <Image source={{ uri: user.profile_information?.avatar.img }} style={{ width: 100, height: 100, borderRadius: 50, alignSelf: 'center', margin: 10, flex: 1 }} />
          </View>
          <View style={{ flex: 3, backgroundColor: 'white', borderTopRightRadius: 20, borderBottomRightRadius: 20, paddingVertical: 30 }} >
            <Text style={{ fontSize: 24, fontWeight: 'bold', color: 'black', textAlign: 'center' }}>{toTitleCase(user.profile_information?.name)} {toTitleCase(user.profile_information?.surname)}</Text>
            <Text style={{ fontSize: 18, fontWeight: '600', color: 'black', textAlign: 'center' }}>{user.email}</Text>
          </View>
        </View>
        <View style={{ flex: 1, flexDirection: 'row', paddingVertical: 10 }}>
          <AnimatedLottieView autoPlay loop={false} style={{ flex: 2, height: Platform.OS === 'web' ? '100%' : '10%' }} source={require('@assets/animations/107653-trophy.json')} />
          <Text style={{ fontSize: 30, flex: 3, alignSelf: 'center' }}>
            <CountUp isCounting={true} start={0} end={user.achievements?.achievement_points} />
            <Text adjustsFontSizeToFit style={{ fontSize: 12 }}>pts</Text>
          </Text>
        </View>
      </View>
    </Modal>
  )
});

export default UserInfoModal;